<template>
  <v-container fluid px-0 mt-0>
    <span class="subtitle-2"
      >{{ externoCamposDatosServicios.descripcionLabel }}
      {{
        externoCamposDatosServicios.requerido === true
          ? "*"
          : ""
      }}</span
    >
    <div
      v-if="externoCamposDatosServicios.idCampoFkNavigation.dscTipo === 'text'"
    >
      <v-text-field
        v-if="disabledEmpleador"
        :value="
          externoCamposDatosServicios.externoDatosComplementarios[0].valor
        "
        :rules="[
          (v) =>
            v !== '' ||
            externoCamposDatosServicios.requerido === false ||
            'Campo requerido',
        ]"
        :required="externoCamposDatosServicios.requerido == true"
        readonly
        solo
      />

      <v-text-field
        v-else
        v-model="valor"
        :rules="[
          (v) =>
            v !== '' ||
            externoCamposDatosServicios.requerido === false ||
            'Campo requerido',
        ]"
        :required="externoCamposDatosServicios.requerido == true"
        :readonly="readonly"
        solo
        @input="setValue(externoCamposDatosServicios.idCampoDatoServPk, valor)"
      />
    </div>



    <div
      v-if="externoCamposDatosServicios.idCampoFkNavigation.dscTipo === 'textArea'"
    >
      <v-textarea
        v-model="valor"
        auto-grow
        rows="1"
        :rules="[
          (v) =>
            v !== '' ||
            externoCamposDatosServicios.requerido === false ||
            'Campo requerido',
        ]"
        :required="externoCamposDatosServicios.requerido == true"
        :readonly="readonly"
        solo
        @input="setValue(externoCamposDatosServicios.idCampoDatoServPk, valor)"
      />
    </div>



    <v-select
      v-if="
        externoCamposDatosServicios.idCampoFkNavigation.dscTipo ===
          'lista_padre' ||
          externoCamposDatosServicios.idCampoFkNavigation.dscTipo ===
            'lista_hijo' ||
          externoCamposDatosServicios.idCampoFkNavigation.dscTipo === 'lista'
      "
      v-model="itemSelected"
      :items="items"
      :loading="loading"
      :disabled="disabled"
      :item-text="texto"
      :rules="[(v) => !!v || externoCamposDatosServicios.requerido === false || 'Campo requerido']"
      label="Seleccione una opción"
      return-object
      solo
      :required="externoCamposDatosServicios.requerido == true"
      @change="
        setValue(
          externoCamposDatosServicios.idCampoDatoServPk,
          itemSelected,
          items
        )
      "
    />

    <v-autocomplete
      v-if="
        externoCamposDatosServicios.idCampoFkNavigation.dscTipo ===
          'lista_empleador'
      "
      v-model="itemSelected"
      :items="itemsSearch"
      :loading="loading"
      :search-input.sync="search"
      hide-no-data
      hide-selected
      item-text="Description"
      item-value="id"
      placeholder="Por favor escriba el R.F.C, razón social o nombre comercial"
      solo
      return-object
      clearable
      @change="
        setValue(
          externoCamposDatosServicios.idCampoDatoServPk,
          itemSelected,
          items
        )
      "
    ></v-autocomplete>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getItemsList } from "@/api";
import { parse } from "@babel/core";

export default {
  name: "TextFieldDynamic",
  components: {},
  props: {
    externoCamposDatosServicios: {
      type: Object,
      required: true,
    },
    itemsHijos: {
      type: Array,
      default: [],
    },
    setValue: {
      type: Function,
      required: true,
    },
    idEstatus: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      valor: "",
      itemSelected: null,
      items: [],
      loading: false,
      disabled: false,
      readonly: false,
      search: null,
      descriptionLimit: 60,
      entries: [],
      disabledEmpleador: false,
    };
  },
  computed: {
    ...mapGetters("oidc", ["oidcUser"]),
    itemsSearch() {
      return this.entries.map((entry) => {
        const Description = entry.descripcion;

        return Object.assign({}, entry, { Description });
      });
    },
  },
  watch: {
    itemsHijos: {
      handler(newValue, oldValue) {
        if (
          this.externoCamposDatosServicios.idCampoFkNavigation
            .idCampoPadreFk !== null
        ) {
          if (newValue.length === 0) {
            this.disabled = true;
            this.items = [];
          } else {
            this.disabled = false;
            this.items = newValue;
            if (this.itemSelected.ban === undefined) {
              this.itemSelected = null;
            }
          }
        }
      },
      deep: true,
    },
    search(val) {
      // Items have already been loaded
      if (this.itemsSearch.length > 0) return;

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      // Lazily load input items
      fetch(this.externoCamposDatosServicios.idCampoFkNavigation.origen)
        .then((res) => res.json())
        .then((res) => {
          this.count = res.length;
          this.entries = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
    externoCamposDatosServicios: {
      handler(newValue, oldValue) {
        if (newValue.externoDatosComplementarios.length > 0) {
          if (newValue.externoDatosComplementarios[0].disabled != true) {
            this.valor = newValue.externoDatosComplementarios[0].valor;
            this.disabledEmpleador = false;
          } else {
            this.valor = "";
            this.disabledEmpleador = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted () {
    // if (this.idEstatus == 2 || this.idEstatus == 3) this.readonly = true;
    if (this.idEstatus == 2 || this.idEstatus == 5) this.readonly = true;

    if (this.externoCamposDatosServicios.idCampoFk == 12) {
      this.readonly = true;
      this.valor = this.oidcUser.email;
      this.setValue(
        this.externoCamposDatosServicios.idCampoDatoServPk,
        this.valor
      );
    }

    if (
      this.externoCamposDatosServicios.idCampoDatoServPk == 10 &&
      this.idEstatus == 1
    ) {
      this.valor = "";
      this.setValue(
        this.externoCamposDatosServicios.idCampoDatoServPk,
        this.valor
      );
    }

    var tipo = this.externoCamposDatosServicios.idCampoFkNavigation.dscTipo;

    if (tipo === "lista_padre" || tipo === "lista_hijo" || tipo === "lista") {
      if (
        this.externoCamposDatosServicios.idCampoFkNavigation.idCampoPadreFk !==
        null
      ) {
        this.disabled = true;
        this.items = [];
        this.itemSelected = {
          id: parseInt(
            this.externoCamposDatosServicios.externoDatosComplementarios[0]
              .idValor
          ),
          descripcion: this.externoCamposDatosServicios
            .externoDatosComplementarios[0].valor,
          ban: true,
        };

        this.setValue(
          this.externoCamposDatosServicios.idCampoDatoServPk,
          this.itemSelected,
          this.items
        );
      } else {
        this.getItemsList_();
      }
    } else {
      if (
        this.externoCamposDatosServicios.externoDatosComplementarios.length > 0
      ) {
        if (
          this.externoCamposDatosServicios.externoDatosComplementarios[0]
            .disabled != true
        ) {
          this.valor = this.externoCamposDatosServicios.externoDatosComplementarios[0].valor;
        }
      }
    }

    if (
      this.externoCamposDatosServicios.idCampoFk == 20 &&
      this.idEstatus == 4
    ) {
      this.cargarSeleccionarEmpresaMatriz();
    }
  },
  methods: {
    texto(item) {
      if (item === undefined) {
        return "";
      } else {
        if (
          this.externoCamposDatosServicios.idCampoFkNavigation.dscTipo ===
          "lista_padre"
        ) {
          return item.padre === undefined ? "" : item.padre.descripcion;
        } else {
          return item.descripcion;
        }
      }
    },
    async getItemsList_() {
      var self = this;
      self.loading = true;

      try {
        let response = await getItemsList(
          self.externoCamposDatosServicios.idCampoFkNavigation.origen
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            self.items = response.data.data;
            if(self.externoCamposDatosServicios.idCampoDatoServPk == 40){
              self.items = self.items.filter(function( obj ) {
                  return obj.id !== '1';
              });
            }
            self.loading = false;

            if (
              self.externoCamposDatosServicios.externoDatosComplementarios
                .length > 0
            ) {
              var datoBD =
                self.externoCamposDatosServicios.externoDatosComplementarios[0];

              if (
                self.externoCamposDatosServicios.idCampoFkNavigation.dscTipo ==
                "lista"
              ) {
                self.itemSelected = self.items.filter(
                  (n) => n.id == datoBD.idValor
                )[0];
              } else {
                self.itemSelected = self.items.filter(
                  (n) => n.padre.id == datoBD.idValor
                )[0];
              }

              if (self.itemSelected !== null) {
                self.setValue(
                  self.externoCamposDatosServicios.idCampoDatoServPk,
                  self.itemSelected,
                  self.items
                );
              }
            }
            // if (idSelected !== undefined) {
            //   alert("Hola");
            // }
          } else {
            self.loading = false;
          }
        } else {
          self.loading = false;
        }
      } catch (e) {
        console.log(e);
        self.loading = false;
      }
    },
    async cargarSeleccionarEmpresaMatriz() {
      this.loading = true;

      let response = await fetch(
        this.externoCamposDatosServicios.idCampoFkNavigation.origen
      );
      let data = await response.json();

      this.count = data.length;
      this.entries = data;

      this.loading = false;

      this.disabled = true;
      this.itemSelected = this.entries.filter(
        (n) =>
          n.id ==
          this.externoCamposDatosServicios.externoDatosComplementarios[0]
            .idValor
      )[0];

      this.setValue(
        this.externoCamposDatosServicios.idCampoDatoServPk,
        this.itemSelected,
        this.items
      );
    },
  },
};
</script>
